import EnvHelper from '../helpers/envHelper';

let worker;

export const initializeWorker = () => {
  if (!worker) {
    try {
      const envHelper = EnvHelper.getInstance();
      // eslint-disable-next-line no-undef
      const workerUrl = new URL('./worker.js', import.meta.url);
      
      // Fix hardcoded PUBLIC_URL: replace any .iux.com domain with current origin
      const fixedUrl = envHelper.fixUrl(workerUrl);
      
      console.log('[ServiceWorker] Creating worker with URL:', fixedUrl);
      worker = new Worker(fixedUrl);
    } catch (error) {
      console.error('[ServiceWorker] Failed to create worker:', error);
      // Fallback: try to extract path and use current origin
      try {
        const envHelper = EnvHelper.getInstance();
        // eslint-disable-next-line no-undef
        const metaUrl = import.meta.url;
        if (metaUrl) {
          const url = new URL(metaUrl);
          const currentOrigin = envHelper.getPublicUrl();
          // Extract pathname and replace filename with worker.js
          const path = url.pathname.replace(/[^/]+$/, 'worker.js');
          const fallbackUrl = currentOrigin + path;
          console.log('[ServiceWorker] Fallback - creating worker with URL:', fallbackUrl);
          worker = new Worker(fallbackUrl);
        }
      } catch (fallbackError) {
        console.error('[ServiceWorker] Failed to create worker with fallback:', fallbackError);
      }
    }
  }
  return worker;
};

export const postMessageToWorker = (message) => {
  if (worker) {
    worker.postMessage(message);
  }
};

export const addWorkerMessageListener = (callback) => {
  if (worker) {
    worker.onmessage = callback;
  }
};

export const terminateWorker = () => {
  if (worker) {
    worker.terminate();
    worker = null;
  }
};